import { useState, useRef } from "react";
import { Upload, X } from "lucide-react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function isVideo(url) {
  if (!url) return false;
  const lower = url.toLowerCase();
  return lower.includes('.mp4') || lower.includes('.mov') || lower.includes('.webm') || lower.includes('video');
}

export function MediaPreview({ src, alt, className }) {
  if (!src) return null;
  if (isVideo(src)) {
    return <video src={src} controls className={className} />;
  }
  return <img src={src} alt={alt || ""} className={className} />;
}

export default function ImageUpload({ value, onChange, token }) {
  const [uploading, setUploading] = useState(false);
  const fileRef = useRef(null);

  const handleUpload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    try {
      const formData = new FormData();
      formData.append("file", file);
      const { data } = await axios.post(`${API}/upload`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });
      const url = data.url.startsWith("http") ? data.url : `${process.env.REACT_APP_BACKEND_URL}${data.url}`;
      onChange(url);
    } catch {
      alert("Upload failed. Try again.");
    } finally {
      setUploading(false);
      if (fileRef.current) fileRef.current.value = "";
    }
  };

  return (
    <div data-testid="image-upload" className="space-y-2">
      {value && (
        <div className="relative inline-block">
          {isVideo(value) ? (
            <video src={value} className="h-24 w-auto bg-foreground p-1" controls muted />
          ) : (
            <img src={value} alt="Preview" className="h-24 w-auto object-contain bg-foreground p-1" />
          )}
          <button
            type="button"
            onClick={() => onChange("")}
            className="absolute -top-2 -right-2 bg-red-800 text-white w-5 h-5 flex items-center justify-center"
          >
            <X size={12} />
          </button>
        </div>
      )}

      <div className="flex items-center gap-2">
        <label className="cursor-pointer inline-flex items-center gap-2 bg-foreground text-background px-4 py-2 font-heading text-xs uppercase tracking-wider hover:bg-primary hover:text-foreground transition-colors">
          <Upload size={14} />
          {uploading ? "Uploading..." : "Upload Image / Video"}
          <input
            ref={fileRef}
            type="file"
            accept="image/*,video/mp4,video/quicktime,video/webm"
            onChange={handleUpload}
            disabled={uploading}
            className="hidden"
          />
        </label>
        <span className="font-body text-[10px] text-muted-foreground">or paste URL below</span>
      </div>
    </div>
  );
}
